/* action types */
export const REQUEST_IDENTITY_VERIFICATION = 'REQUEST_IDENTITY_VERIFICATION';
export const REQUEST_IDENTITY_VERIFICATION_ERROR = 'REQUEST_IDENTITY_VERIFICATION_ERROR';
export const RECEIVE_IDENTITY_VERIFICATION = 'RECEIVE_IDENTITY_VERIFICATION';
export const CLEAR_IDENTITY_VERIFICATION_GET_STATUS = 'CLEAR_IDENTITY_VERIFICATION_GET_STATUS';
export const REQUEST_POST_IDENTITY_VERIFICATION = 'REQUEST_POST_IDENTITY_VERIFICATION';
export const REQUEST_POST_IDENTITY_VERIFICATION_ERROR = 'REQUEST_POST_IDENTITY_VERIFICATION_ERROR';
export const RECEIVE_POST_IDENTITY_VERIFICATION = 'RECEIVE_POST_IDENTITY_VERIFICATION';
